export default function WorkstationsDirective() {
  return {
    template: require('./workstations.html'),
    scope: {
      assessmentId: '=',
      workstations: '=',
      hasNetcomply: '=',
      hasDatto: '=',
      addCallback: '&',
      deleteCallback: '&',
      customerId: '=',
      tooltipAppendToSelector: '@',
      status: '=',
    },
    controller: 'WorkstationsController',
    controllerAs: 'workstationsVM',
    bindToController: true,
    replace: true,
  };
}
